import { useEffect, useRef } from 'react'
import { useGlobalNavigation } from 'src/contexts/global-navigation-context'
import { LEVELS } from '../constants'
import { MenuSection } from './MenuComponents/MenuSection/MenuSection'
import { TopCategorySection } from './MenuComponents/MenuSection/TopCategorySection'

export const FirstLevel = () => {
  const scrollRef = useRef<HTMLDivElement>(null)

  const { openCloseMenu, menuSections } = useGlobalNavigation()

  useEffect(() => {
    if (openCloseMenu) {
      scrollRef?.current?.scrollTo(0, 0)
    }
  }, [openCloseMenu])

  return (
    <div className="navigation-panel-step active" ref={scrollRef}>
      <div className="px-6 pt-6 [&amp;>div:last-child]:border-none">
        {menuSections.map((el, index: number) => (
          <MenuSection
            key={`menu-mobile-section-${index}`}
            menu={el}
            type={LEVELS.main.toString()}
          />
        ))}
      </div>
      <TopCategorySection />
    </div>
  )
}
